import { render, staticRenderFns } from "./TextForNextReport.vue?vue&type=template&id=6e0a6122&scoped=true&lang=html&"
import script from "./TextForNextReport.vue?vue&type=script&lang=js&"
export * from "./TextForNextReport.vue?vue&type=script&lang=js&"
import style0 from "./TextForNextReport.vue?vue&type=style&index=0&id=6e0a6122&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e0a6122",
  null
  
)

component.options.__file = "TextForNextReport.vue"
export default component.exports